import type { StaticImport } from "next/dist/shared/lib/get-img-props"

import { YOUTUBE_URL_REGEX } from "@/features/companyDetail/components/shared/Media/constants"
import youtubePlayIcon from "@/features/companyDetail/components/shared/Media/images/youtube_play_icon.png"

import styles from "@/features/companyDetail/components/shared/Media/Media.module.css"

type PlayIconProps = {
  className: string
  src: string | StaticImport
}

export const getPlayIconProps = (videoUrl: string): PlayIconProps => {
  const videoUrlMatch = videoUrl.match(YOUTUBE_URL_REGEX)
  if (videoUrlMatch) {
    return {
      className: styles.youtubePlayIcon,
      src: youtubePlayIcon,
    }
  }
  return {
    className: "",
    src: "",
  }
}
